import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { Stack } from '@mui/material';

import { Button } from '../Form/Button';
import { cartCheckout } from '../../api';

export const CheckoutForm = ({
  clientSecret,
  onSuccess,
  onProccess,
  onCancel,
  onError,
  orderId,
  customer,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [complete, setComplete] = useState(null);
  const [success, setSuccess] = useState(null);
  const [processing, setProcessing] = useState(false);
  const handleOnChange = e => {
    console.log('onChange', e);
    if (e.complete) {
      setComplete(true);
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setProcessing(true);
    onProccess(
      (await stripe.retrievePaymentIntent(clientSecret)).paymentIntent
    );
    const zip = customer.primaryBilling.zipcode;
    stripe
      .confirmPayment({
        elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: customer.firstName?.concat(' ', customer.lastName) || '',
              email: customer.email || '',
              phone: customer.phoneNumber || '+15555555555',
              address: {
                country: customer.country,
                // zip,
              },
            },
          },
        },
        redirect: 'if_required',
      })
      .then(async result => {
        if (result?.paymentIntent?.status === 'requires_capture') {
          const checkoutResponse = await cartCheckout(
            orderId,
            result.paymentIntent.id
          );

          if (checkoutResponse.status === 'succeeded') {
            // elements.getElement('payment').destroy();
            onSuccess({
              ...checkoutResponse,
              ...(await stripe.retrievePaymentIntent(clientSecret))
                .paymentIntent,
            });
            return;
          }
        }
        if (result?.paymentIntent?.status === 'succeeded') {
          onSuccess(result);
        }
        // if (result?.paymentIntent?.status === 'processing') {
        //   onProccess({ ...result, paymentIntent: result.paymentIntent.id });
        // }
        if (result?.error?.message) {
          onError(result?.error?.message);
        }
      })
      .catch(e => onError(e))
      .finally(() => setProcessing(false));
  };

  return (
    <>
      {stripe && (
        <form onSubmit={handleSubmit}>
          <PaymentElement
            onChange={handleOnChange}
            options={{
              fields: {
                billingDetails: {
                  name: 'never',
                  email: 'never',
                  phone: 'never',
                  address: {
                    country: 'never',
                  },
                },
              },
              terms: {
                card: 'never',
              },
              wallets: {
                googlePay: 'never',
                applePay: 'never',
              },
              loader: 'never',
            }}
          />
          <Stack
            direction="row"
            spacing={1}
            justifyContent="space-between"
            alignItems="center"
            padding="20px 0"
          >
            <Button
              id="save-button"
              disabled={!stripe || processing}
              text="Make Payment"
              hoverColor="#555354"
              height="64px"
              className="lab-button"
              style={{ borderRadius: '0px' }}
            />
          </Stack>
        </form>
      )}
    </>
  );
};
